module.exports = __webpack_public_path__ + "img/logo-readcoop.0daacf77.svg";